/**
 * TMR Validate Password directive
 *
 * Asynchronous server-side password validation. The specifics for
 * a valid password are described in the ADMIN.ERRORS.INVALIDPASSWORD
 * translation keys, which can be overridden by customizations,
 * if server validation is changed.
 *
 * @example
 * <md-input-container>
 *   <label>Password</label>
 *   <input name="password" type="password" ng-model="$ctrl.password" tmr-validate-password>
 *   <div ng-messages="$ctrl.userPasswordForm.password.$error">
 *     <div ng-message="tmrValidatePassword" translate>ADMIN.ERRORS.INVALIDPASSWORD</div>
 *   </div>
 * </md-input-container>
 *
 * @namespace
 * @alias tmrValidatePassword
 * @type {ngDirective}
 */
let tmrValidatePasswordDirective = /*@ngInject*/ TmrApiAuth => ({
  link: (scope, elm, attrs, ctrl) => {
    ctrl.$asyncValidators.tmrValidatePassword = value => {
      if (!value) return Promise.resolve(true)
      return TmrApiAuth.checkPassword({ value }).then(valid => {
        if (!valid) throw new Error('Invalid password')
      })
    }
  },
  require: 'ngModel',
})

export const directive = ['tmrValidatePassword', tmrValidatePasswordDirective]
